initslide();

$(document).on('shopify:section:load', function(event) {
  initslide();
});
$(document).on('shopify:section:unload', function(event) {
  $('.u-testim-slider').slick('unslick');
});
function initslide() {
    $('.u-testim-slider').slick({
    infinite: true,
    speed: 400,
    autoplay: true,
    slidesToShow: 3,
    pauseOnHover: false,
    slidesToScroll: 3,
    arrows: false,
    centerMode: true,
    centerPadding: '0px',
    adaptiveHeight: true,
    autoplaySpeed: 5000,
    dots: true,
    responsive: [ 
      {
        breakpoint: 991,
        settings: {
         centerMode: false,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },      
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false
        }
      }
    ]
  });
}

document.addEventListener('DOMContentLoaded', (event) => {
  var coll = document.getElementsByClassName("collapsibleuz");
  for (var i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      if (content.style.maxHeight) {
          content.style.maxHeight = null;
      } else {
          content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  }
});
